import { Injectable } from '@angular/core';
import { ValuesExchangeProvider } from '../../providers/values.exchange/values.exchange.provider';
import { UrlListener } from '../../providers/values.exchange/url.listener';
@Injectable({
  providedIn: 'root'
})
export class AutoRefreshService {
  autoRefreshEnabled = true;
  constructor(
    readonly exchangeProvider: ValuesExchangeProvider,
    readonly urlListener: UrlListener
  ) {
    this.urlListener.registerListener('time_range', this.resetAutoRefresh.bind(this));
  }

  notifyAutoRefreshUpdate(status: boolean): void {
    this.autoRefreshStatus = status;
    this.exchangeProvider.notifyListeners('update_auto_refresh', {
      autoRefresh: status
    });
  }

  notifyPageTriaged(status: boolean, notifyUpdate: boolean): void {
    this.exchangeProvider.notifyListeners('auto_refresh_page_triaged', {
      pageTriaged: status,
      notifyUpdate: notifyUpdate
    });
  }

  resetAutoRefresh(): void {
    this.exchangeProvider.notifyListeners('reset_auto_refresh', {
      timestamp: new Date().getTime()
    });
    this.notifyAutoRefreshUpdate(true);
    this.notifyPageTriaged(false, false);
  }

  set autoRefreshStatus(status: boolean) {
    this.autoRefreshEnabled = status;
  }

  get autoRefreshStatus(): boolean {
    return this.autoRefreshEnabled;
  }
}
